import React, { Component, ErrorInfo, ReactNode } from "react";

import { Alert, Box, Container, Typography } from "@mui/material";

import ErrorGraphic from "assets/error-graphic";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm">
          <ErrorGraphic size={180} />
          <div>
            <Typography variant="h6" gutterBottom>
              Oops! Something went wrong causing Periscope to crash.
            </Typography>
          </div>
          <Box my={3} />
          <div>
            <Typography variant="body1" gutterBottom>
              Please ask #business-systems team for help and include the details
              of which page you were using, any relevant ids and the following
              error:
            </Typography>
          </div>
          <Box my={3} />
          <div>
            <Alert severity="error">{this.state?.error?.message}</Alert>
          </div>
        </Container>
      );
    }

    // Need React fragment here so typescript is happy that we are passing React.Node type
    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
